const ErrorPage = () => {
    return (
        <div>
            <p>P&aacute;gina de error....</p>
        </div>
    )
}

export default ErrorPage;